const __WEBPACK_NAMESPACE_OBJECT__ = require("@redocly/openapi-core");